import { render } from "./BaseInfoDialog.vue?vue&type=template&id=aff25e16"
import script from "./BaseInfoDialog.vue?vue&type=script&lang=js"
export * from "./BaseInfoDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__